import React from "react";
import "./FooterSection.scss";

export default function FooterSection() {
  return (
    <footer className="site-footer">
      <div className="container footer__grid">
        <div>
          <h4>Wushu / Kungfu klubs</h4>
          <p className="muted">© {new Date().getFullYear()} Visas tiesības aizsargātas.</p>
          <ul className="socials">
            <li><a href="https://instagram.com" target="_blank" rel="noreferrer">Instagram</a></li>
            <li><a href="https://facebook.com" target="_blank" rel="noreferrer">Facebook</a></li>
            <li><a href="https://youtube.com" target="_blank" rel="noreferrer">YouTube</a></li>
          </ul>
        </div>

        <div>
          <h4>Rekvizīti</h4>
          <ul className="muted">
            <li>Nosaukums: Wushu Club</li>
            <li>Reģ. Nr.: 4000xxxxxxx</li>
            <li>IBAN: LVxxBANKxxxxxxxxxxxx</li>
          </ul>
        </div>

        <div>
          <h4>Draugi un partneri</h4>
          <ul className="muted">
            <li>Top Ring</li>
            <li>WAKO Latvia</li>
            <li>Fun Catchers</li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
